<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">原密码</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="password" v-model="oldPassword" placeholder="请填写" />
          </div>
        </div>
      </div>
      <div class="weui-cells__title">
        <span>密码须为8-20字符的英文、数字混合</span>
      </div>
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">新密码</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="password" v-model="newPassword" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">确认密码</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="password" v-model="verPassword" placeholder="请填写" />
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="resetPass">完成</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mobile: String
  },
  data() {
    return {
      oldPassword: null,
      newPassword: null,
      verPassword: null
    };
  },
  methods: {
    /**
     * 重置密码
     */
    resetPass() {
      var me = this,
        oldPassword = me.oldPassword,
        password = me.newPassword;
      if (!oldPassword) {
        me.$weui.topTips("请填写原密码", 3000);
      } else if (!password) {
        me.$weui.topTips("请填写新密码", 3000);
      } else if (password != me.verPassword) {
        me.$weui.topTips("两次密码输入不一致", 3000);
      } else if (password == oldPassword) {
        me.$weui.topTips("原密码与新密码相同", 3000);
      } else {
        me.$loading({
          url: "/api/auth/password/reset_by_pass",
          method: "POST",
          params: {
            oldPassword,
            password,
            mobile: me.mobile
          }
        })
          .then(function(res) {
            if (res.success) {
              me.$weui.toast("设置成功", 2000);
              me.$router.go(-2);
            } else {
              me.$weui.topTips(res.message, 3000);
            }
          })
          .catch(function() {
            me.$weui.topTips("设置失败", 3000);
          });
      }
    }
  }
};
</script>